import React, { useEffect, useRef, useState } from "react";
import "../../styles/Organize.css";

import step1 from "../../assets/step1.png";
import step2 from "../../assets/step2.png";
import step3 from "../../assets/step3.png";
import step4 from "../../assets/step4.png";

const STEPS = [
  {
    id: 1,
    step: "01",
    image: step1,
    title: "Meet Client",
    desc: "We begin by discussing client requirements, space, usage, and style preferences.",
  },
  {
    id: 2,
    step: "02",
    image: step2,
    title: "Material Selection",
    desc: "We provide options for premium wood, finishes, and fittings.",
  },
  {
    id: 3,
    step: "03",
    image: step3,
    title: "Execution Stage",
    desc: "Every piece undergoes strict quality inspection before delivery.",
  },
  {
    id: 4,
    step: "04",
    image: step4,
    title: "Delivery & Installation",
    desc: "Timely installation and onsite care to ensure a clean experience.",
  },
];

const isTouchDevice = () =>
  typeof window !== "undefined" &&
  ("ontouchstart" in window || navigator.maxTouchPoints > 0);

const Organize = () => {
  const [openId, setOpenId] = useState(null);
  const railRef = useRef(null);

  const handleLeaveRail = () => {
    if (!isTouchDevice()) setOpenId(null);
  };

  useEffect(() => {
    const onEsc = (e) => e.key === "Escape" && setOpenId(null);
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, []);

  useEffect(() => {
    const onDocClick = (e) => {
      if (!railRef.current) return;
      if (!railRef.current.contains(e.target)) setOpenId(null);
    };
    document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, []);

  return (
    <section className="org-section" style={{ minHeight: "100vh", padding: "100px 20px" }} aria-labelledby="org-title">
      <div className="org-container">
        <header className="org-header">
          <h2 id="org-title">How Organization works</h2>
          <p className="org-sub">
            At icity woodworks, we employ a streamlined approach to create bespoke woodwork
            solutions tailored to your needs. Our expert team ensures precision, quality,
            and craftsmanship at every stage.
          </p>
        </header>

        {/* Interactive rail */}
        <div
          className="org-rail"
          ref={railRef}
          onMouseLeave={handleLeaveRail}
          role="list"
          aria-label="Project workflow"
        >
          {STEPS.map((s) => {
            const open = openId === s.id;
            const collapsed = openId && openId !== s.id;
            const cls = open
              ? "org-card open"
              : collapsed
                ? "org-card collapsed"
                : "org-card idle";

            return (
              <article
                key={s.id}
                className={cls}
                role="listitem"
                tabIndex={0}
                onMouseEnter={() => !isTouchDevice() && setOpenId(s.id)}
                onFocus={() => setOpenId(s.id)}
                onClick={() => setOpenId(open ? null : s.id)}
              >

                <div className="org-media">
                  <img src={s.image} alt={s.title || "Step image"} loading="lazy" />
                  <span className="org-step-index">{s.step}</span>
                </div>

                {/* Gradient for legibility */}
                <div className="org-gradient" aria-hidden="true" />

                {/* Bottom content panel */}
                <div className="org-panel">
                  <h3 className="org-title">{s.title}</h3>
                  <p className="org-desc">{s.desc}</p>
                  <button className="org-cta" type="button" aria-label="Next">
                    <svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">
                      <path
                        d="M8 5l7 7-7 7"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </article>
            );

          })}
        </div>
      </div>
    </section>
  );
};

export default Organize;
